import { ref, computed, reactive } from "vue";
import bus from "@/bus/index";
import { useRenderConfig } from "./useRenderConfig";
import { cssTextToJsObjWithBindData } from "@/utils/renderBinding";

export function useElementIndex(props) {
  const platformType = ref("web");

  const renderData = ref([]);
  
  const rectBox = reactive({
    width: 10,
    height: 10,
  });

  const { bindData, filterConfig, setStyle, showStatus } = useRenderConfig(
    () => props.itemData?.config,
  );

  const componentName = computed(() => {
    const type = props.itemData?.type === "shopNavigationBar"
      ? "navigationBar"
      : props.itemData?.type;
    return type ? firstToUpper1(type) : "";
  });

  const currentElementIndexStr = computed(() => {
    return props.currentElementIndex && props.currentElementIndex.length
      ? props.currentElementIndex.join("x")
      : "";
  });

  const itemIdxStr = computed(() => {
    return [...props.parentKeys, props.idx].join("x");
  });

  const isPosition = computed(() => {
    return (
      filterConfig.value?.position
      && filterConfig.value.position !== "static"
      && !!filterConfig.value.positionVal
    );
  });

  // 方法
  const firstToUpper1 = (str) => {
    return str.trim().replace(str[0], str[0].toUpperCase());
  };

  // 用于发射事件
  const emitAction = (action, idx) => {
    bus.$emit(action, [...props.parentKeys, idx]);
  };

  const selectElement = (idx) => emitAction('selectPcElement', idx);
  const removeElement = (idx) => emitAction('removePcElement', idx);
  const copyElement = (idx) => emitAction('copyPcElement', idx);
  const moveElementUp = (idx) => emitAction('movePcElementUp', idx);
  const moveElementDown = (idx) => emitAction('movePcElementDown', idx);
  const setRenderData = (data) => {
    renderData.value = data;
  };

  return {
    platformType,
    renderData,
    bindData,
    filterConfig,
    rectBox,
    componentName,
    setStyle,
    showStatus,
    currentElementIndexStr,
    itemIdxStr,
    isPosition,
    selectElement,
    removeElement,
    copyElement,
    moveElementUp,
    moveElementDown,
    setRenderData,
  };
}


export function toSetElementStyle(config, bindData = {}) {
  return cssTextToJsObjWithBindData(config?.styles || "", bindData);
}
